import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
//Material
import { TextField, Button } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
//Components
import { useSyles } from './styles.style';
import Layout from '../common/Layout';
import Loading from '../common/Loading';
// Redux
import { useSelector, useDispatch } from 'react-redux';
import { getAllWarehouses } from '../../redux/warehouses/thunks';
import { setCurrent } from '../../redux/renovation/thunk';
type PropsForm = {
  submitDrawer: (_: any) => void;
  initialValues: any;
  actionText?: any;
};
const Form = ({ submitDrawer, initialValues, actionText }: PropsForm) => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const classes = useSyles();
  useEffect(() => {
    const filter = `&status_warehouses_id=1`;
    dispatch(getAllWarehouses({ filter, pagination: {} }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Acceder al state del store
  const { warehouses, loading } = useSelector(
    (state: any) => state.warehouses.warehouses
  );
  const renovation = useSelector((state: any) => state.renovation);

  useEffect(() => {
    if (renovation.actionInProcess) {
      if (renovation.process.prefix.toLowerCase() === 'alm') {
        formik.values.warehouses_id = renovation.process.id;
        dispatch(
          setCurrent({
            currentView: renovation.currentView,
            url: renovation.url,
            actionInProcess: false,
            process: {},
            title: renovation.title,
          })
        ).unwrap();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renovation.actionInProcess]);

  // función que redirige de forma programada
  const cancelAdd = () => {
    navigate(`/drawers`, { replace: true });
  };

  const onAction = () => formik?.handleSubmit();

  const validationSchema = yup.object({
    rack: yup.string().required('Campo obligatorio'),
    drawer_row: yup.string().required('Campo obligatorio'),
    drawer_column: yup.string().required('Campo obligatorio'),
    warehouses_id: yup.number().required('Campo obligatorio'),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values: any) => submitDrawer(values),
  });

  return (
    <Layout>
      <div className={classes.container}>
        {!loading ? (
          <form className={classes.form} onSubmit={formik.handleSubmit}>
            <FormControl variant='outlined'>
              <InputLabel>Almacen</InputLabel>
              <Select
                id='form-warehouses_id'
                name='warehouses_id'
                value={formik.values.warehouses_id}
                onChange={formik.handleChange('warehouses_id')}
                error={
                  formik.touched.warehouses_id &&
                  Boolean(formik.errors.warehouses_id)
                }
                label='Almacen'
              >
                <MenuItem value=''>
                  <em>Selecciona un almacen</em>
                </MenuItem>
                {warehouses.map((warehouse: any) => {
                  return (
                    <MenuItem
                      value={warehouse.id}
                      key={`warehouse-${warehouse.id}`}
                    >
                      {warehouse.name} ({warehouse.barcode})
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <TextField
              id='form-rack'
              name='rack'
              label='Rack'
              variant='outlined'
              fullWidth
              value={formik.values.rack}
              onChange={formik.handleChange}
              error={formik.touched.rack && Boolean(formik.errors.rack)}
            />
            <TextField
              id='form-drawer_row'
              name='drawer_row'
              label='Fila'
              variant='outlined'
              fullWidth
              value={formik.values.drawer_row}
              onChange={formik.handleChange}
              error={
                formik.touched.drawer_row && Boolean(formik.errors.drawer_row)
              }
            />
            <TextField
              id='form-drawer_column'
              name='drawer_column'
              label='Columna'
              variant='outlined'
              fullWidth
              value={formik.values.drawer_column}
              onChange={formik.handleChange}
              error={
                formik.touched.drawer_column &&
                Boolean(formik.errors.drawer_column)
              }
            />
            <div className={classes.flex}>
              <Button onClick={cancelAdd}>Cancelar</Button>
              <Button
                className={classes.button}
                size='medium'
                color='secondary'
                variant='contained'
                onClick={onAction}
              >
                {actionText}
              </Button>
            </div>
          </form>
        ) : (
          <Loading />
        )}
      </div>
    </Layout>
  );
};

export default Form;
